import { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { StoreAssetUploadDataType, StoreUploadLocalizeData } from '../../../../types/StoreTypes';
import UploadLocalesSelection from './UploadLocalesSelection';
import UploadLocalizeFormAccordion from './UploadLocalizeFormAccordion';

/**
 * 상세정보 입력 폼(모든 타입 공통)
 * @param props
 * @constructor
 */
const UploadDetailForm = (props: AssetUploadDetailFormProps) => {
  const [selectedLocales, setSelectedLocales] = useState<string[]>([]);
  const [isLocaleFormDirties, setIsLocaleFormDirties] = useState<Record<string, boolean>>({});
  const [localeForms, setLocaleForms] = useState<Record<string, UseFormReturn<StoreUploadLocalizeData>>>({});
  const newLocaleForms: Record<string, UseFormReturn<StoreUploadLocalizeData>> = {};
  const {
    isEditBlocked,
    commonForm,
    onChangeLocaleForms
  } = props;
  const [initialLocalizeValues, setInitialLocalizeValues] = useState({
    ...commonForm.getValues().localizeDataSets
  });
  const initialLocales = Object.keys(initialLocalizeValues ?? {});

  /**
   * 언어 선택값 변경 이벤트
   * @param localeIds
   */
  const changeSelectedLocale = (localeIds: string[]) => {
    setSelectedLocales([...localeIds]);

    // 삭제된 언어 폼에 대한 대응
    const removedLocales = selectedLocales.filter(value => !localeIds.includes(value));
    if (removedLocales.length > 0) {
      removedLocales.forEach(localeId => {
        delete localeForms[localeId];
      });
      setLocaleForms({
        ...localeForms
      });
    }
  };

  /**
   * 언어 폼 생성 이덴트
   * @description 상태 전달을 위해 폭 객체 목록에 추가 처리
   * @param localeId
   * @param form
   */
  const addLocaleForms = (localeId: string, form: UseFormReturn<StoreUploadLocalizeData>) => {
    // 선택된 언어 초기값에 대한 기존 입력값 세팅
    if (initialLocalizeValues && initialLocalizeValues[localeId]) {
      form.reset(initialLocalizeValues[localeId]);

      // 해당 폼을 한번 삭제한 후 재등록하는 경우, 초기값으로 인정하지 않도록 초기값 목록에서 제거
      delete initialLocalizeValues[localeId];
      setInitialLocalizeValues({
        ...initialLocalizeValues
      });
    }
    newLocaleForms[localeId] = form; // 렌더링을 다시 수행되기 전에 setState가 두번 이상 발생하는 케이스에 대한 대응
    setLocaleForms({
      ...localeForms,
      ...newLocaleForms
    });
  };

  /**
   * 입력폼 Dirty 상태를 업데이트(언어 선택 컴포넌트에 전달을 위해 수행)
   * @param localeId
   * @param value
   */
  const changeLocaleFormDirtyState = (localeId: string, value: boolean) => {
    setIsLocaleFormDirties({
      ...isLocaleFormDirties,
      [localeId]: value
    });
  };
  useEffect(() => {
    // 언어별 폼이 추가/삭제/수정 시 부모 컴포넌트에게 전달(폼과 Dirty 상태)
    onChangeLocaleForms && onChangeLocaleForms(localeForms, Object.values(isLocaleFormDirties).some(value => value));
  }, [localeForms, isLocaleFormDirties]);
  return <>
      {/* 언어 선택 컴포넌트 */}
      <UploadLocalesSelection initializedLocales={initialLocales} isLocaleFormDirties={isLocaleFormDirties} onChange={changeSelectedLocale} data-sentry-element="UploadLocalesSelection" data-sentry-source-file="UploadDetailForm.tsx" />

      {/* 선태된 언어 폼 컴포넌트 리스트 */}
      {selectedLocales.map((localeId, index) => <UploadLocalizeFormAccordion key={localeId} dataSetIndex={index} localeId={localeId} isEditBlocked={isEditBlocked} onCreateFormData={addLocaleForms} onFormDirty={changeLocaleFormDirtyState} />)}
    </>;
};
export default UploadDetailForm;
type AssetUploadDetailFormProps = {
  isEditBlocked: boolean;
  onChangeLocaleForms?: (localeForms: Record<string, UseFormReturn<StoreUploadLocalizeData>>, isLocaleFormDirty: boolean) => void;
  commonForm: UseFormReturn<StoreAssetUploadDataType>;
};